export const formatTanggal = (tanggalString) => {
  const tanggal = new Date(tanggalString);
  const tgl = String(tanggal.getDate()).padStart(2,'0');
  const bln = String(tanggal.getMonth()+1).padStart(2,'0');
  const thn = tanggal.getFullYear();
  return `${tgl}-${bln}-${thn}`;  
}

export const formatRupiah = (jumlah) => {
  if (!jumlah) return "0";
  const formattedValue = new Intl.NumberFormat('id-ID',{ minimumFractionDigits: 2,
    maximumFractionDigits: 2}).format(jumlah) ;
  return `${formattedValue}`
}

export const capitalizeWords = (str) => {
  if (!str) return "-";
  return str
    .toLowerCase()
    .replace(/\b\w\b|\b\w+/g, (word) => word.charAt(0).toUpperCase() + word.slice(1));
}


